import reducer from './reducers';

import * as notificationActions from './actions';
import * as notificationTypes from './types';

export {
  notificationActions,
  notificationTypes,
};

export default reducer;
